import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRouter } from 'vue-router'

import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import Button from '@/popup/components/shared/Button.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Relayer',
  setup(__props) {

const router = useRouter()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Button, {
    variant: "secondary",
    "is-full-width": true,
    class: "mt-2",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (
      _unref(router).push({
        name: 'listRelayer',
      })
    ))
  }, {
    default: _withCtx(() => [
      _createVNode(SvgIcon, {
        class: "mr-2",
        color: "var(--neutral-20)",
        name: "infinite"
      }),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('settings.network.relayers_button')), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }))
}
}

})